import React, { Component } from 'react'
import { Modal, Form, Input, Radio, Row, Col, Button, Popconfirm } from 'antd'
import { api } from '../../../services'
import { gradients } from '../../../constants'

class channelEditModal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      name: null,
      error: {
        status: false,
        message: ''
      },
      coverType: null,
      coverAvatar: null,
      coverGradient: 0,
      avatar: null,
      deleteLoading: false
    }
  }

  onCoverTypeChange = (e) => {
    this.setState({
      coverType: e.target.value,
      coverAvatar: null,
      avatar: null
    })
  }

  onAvatarSelect = (e) => {
    const { form: { setFields } } = this.props

    if (e.target.files[0]) {
      if (e.target.files[0].size > 3145728) {
        setTimeout(() => {
          setFields({
            avatar: {
              value: null,
              errors: [new Error('File size more than 3Mb')]
            }
          })
        }, 100)
        this.setState({
          coverAvatar: null,
          avatar: null
        })
      } else if ((e.target.files[0].type !== 'image/png') && (e.target.files[0].type !== 'image/jpeg') && (e.target.files[0].type !== 'image/bmp')) {
        setTimeout(() => {
          setFields({
            avatar: {
              value: null,
              errors: [new Error('Wrong file type')]
            }
          })
        }, 100)
        this.setState({
          coverAvatar: null,
          avatar: null
        })
      } else {
        this.setState({
          coverAvatar: window.URL.createObjectURL(e.target.files[0]),
          avatar: e.target.files[0]
        })
      }
    } else {
      this.setState({
        coverAvatar: null,
        avatar: null
      })
    }
  }

  setError = (status, message = null) => {
    this.setState(state => ({
      error: {
        status,
        message
      }
    }))
  }

  handleCancel = (e) => {
    const { closeModal } = this.props

    this.setState({
      name: null,
      error: {
        status: false,
        message: ''
      },
      coverType: null,
      coverAvatar: null,
      coverGradient: 0,
      avatar: null
    })

    closeModal()
  }

  handleDelete = () => {
    const { selectedChannel, deleteStorageById, closeModal } = this.props

    this.setState({
      deleteLoading: true
    })

    deleteStorageById(selectedChannel.id).then(() => {
      closeModal()
      this.setState({
        deleteLoading: false
      })
    }).catch(() => {
      this.setState({
        deleteLoading: false
      })
    })
  }

  handleSave = (e) => {
    const { selectedChannel, form: { validateFields } } = this.props
    const { coverType, avatar, coverGradient } = this.state

    e.preventDefault()

    validateFields((err, values) => {
      if (!err) {
        if (coverType === 'image' && avatar) {
          values.avatar = avatar
        }

        if (coverType === 'gradient') {
          values.firstColor = gradients[coverGradient].firstColor
          values.secondColor = gradients[coverGradient].secondColor
          api.channel.deleteChannelAvatarById(selectedChannel.id)
        }

        this.setError(false)

        if (coverType === 'gradient') {
          api.channel.deleteChannelAvatarById(selectedChannel.id).then(() => {
            this.handleUpdate(values)
          })
        } else {
          this.handleUpdate(values)
        }
      }
    })
  }

  handleUpdate = (values) => {
    const { selectedChannel, updateChannelById, getChannelById } = this.props

    updateChannelById(selectedChannel.id, values).then(response => {
      if (response && response.data.error) {
        this.setError(true, response.data.error.message)
      } else {
        getChannelById(selectedChannel.id)
        this.handleCancel()
      }
    })
  }

  componentDidMount () {
    const { selectedChannel } = this.props

    if (selectedChannel.avatar && selectedChannel.avatar.exists) {
      this.setState({
        coverType: 'image'
      })
    } else if (selectedChannel.firstColor && selectedChannel.secondColor) {
      const gradientIndex = gradients.findIndex(gradient => gradient.firstColor === selectedChannel.firstColor)

      this.setState({
        coverType: 'gradient',
        coverGradient: gradientIndex
      })
    }
  }

  render () {
    const { status, selectedChannel, form: { getFieldDecorator } } = this.props
    const { coverType, coverAvatar, coverGradient, deleteLoading, error, name } = this.state

    const layout = {
      labelCol: {
        md: { span: 12 }
      },
      wrapperCol: {
        md: { span: 12 }
      }
    }

    let cardStyle = {
      backgroundImage: null
    }

    if (coverType === 'image' && selectedChannel.avatar && coverAvatar === null) {
      cardStyle.backgroundImage = 'url(' + api.channel.getChannelAvatarById(selectedChannel.id) + ')'
    } else if (coverType === 'image') {
      cardStyle.backgroundImage = 'url(' + coverAvatar + ')'
    } else if (coverType === 'gradient') {
      cardStyle.backgroundImage = 'linear-gradient(90deg, ' + gradients[coverGradient].firstColor + ' 0%, ' + gradients[coverGradient].secondColor + ' 100%)'
    } else if (selectedChannel.avatar) {
      cardStyle.backgroundImage = 'url(' + api.channel.getChannelAvatarById(selectedChannel.id) + ')'
    } else {
      cardStyle.backgroundImage = 'linear-gradient(90deg, ' + selectedChannel.firstColor + ' 0%, ' + selectedChannel.secondColor + ' 100%)'
    }

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        title='Edit Channel'
        visible={status}
        onCancel={this.handleCancel}
        destroyOnClose
        footer={
          <div className='controls-between'>
            <Popconfirm placement='topLeft' title='Are you sure delete this channel?' onConfirm={this.handleDelete} okType='red' okText='Yes' cancelText='No' >
              <Button type='red' icon='delete' loading={deleteLoading} >Delete</Button>
            </Popconfirm>
            <Button type='indigo' onClick={this.handleSave}>Save</Button>
          </div>
        }
      >
        <Form onSubmit={this.handleSave} className='form'>
          { error.status && <div className='form__error'>{ error.message }</div> }
          <Row>
            <Col span={12}>
              <div className='ant-form-item-label'>
                <label className='ant-form-item' title='Channel Name'>Channel Name</label>
              </div>
            </Col>
            <Col span={12}>
              <Form.Item>
                {getFieldDecorator('name', {
                  rules: [{
                    required: true,
                    message: 'Please input channel name',
                    max: 24,
                    pattern: /^[^ ][ a-zA-Z_\\-\\.0-9]*/
                  }],
                  initialValue: selectedChannel.name
                })(
                  <Input name='name' maxLength={24} onKeyUp={(e) => this.setState({ name: e.target.value })} />
                )}
              </Form.Item>
            </Col>
          </Row>

          <Form.Item {...layout} label='Background Type'>
            <Radio.Group defaultValue={coverType} onChange={this.onCoverTypeChange}>
              <Radio.Button value='image'>Image</Radio.Button>
              <Radio.Button value='gradient'>Gradient</Radio.Button>
            </Radio.Group>
          </Form.Item>

          <div style={{ height: '140px' }}>

            { coverType === 'image' &&
              <Row>
                <Col span={12}>
                  <div className='ant-form-item-label'>
                    <label className='ant-form-item' title='Background Image'>Upload an image</label>
                  </div>
                </Col>
                <Col span={12}>
                  <Form.Item>
                    {getFieldDecorator('avatar', {
                      rules: [{
                        required: true,
                        message: 'Please choose channel avatar'
                      }]
                    })(
                      <Input type='file' accept='image/*' name='avatar' onChange={this.onAvatarSelect} />
                    )}
                  </Form.Item>
                </Col>
              </Row> }

            { coverType === 'gradient' &&
              <Row>
                <Col span={12}>
                  <div className='ant-form-item-label'>
                    <label className='ant-form-item' title='Select a gradient'>Select a gradient</label>
                  </div>
                </Col>
                <Col span={12}>
                  <div className='channel-gradients'>
                    { gradients.map((item, index) =>
                      <div
                        className={coverGradient === index ? 'channel-gradients__item channel-gradients__item_active' : 'channel-gradients__item'}
                        onClick={() => this.setState({ coverGradient: index })}
                        key={index}
                        style={{ backgroundImage: 'linear-gradient(90deg, ' + gradients[index].firstColor + ' 0%, ' + gradients[index].secondColor + ' 100%)' }} />) }

                  </div>
                </Col>
              </Row> }

          </div>

          <div className='channel-preview'>
            <Row>
              <Col span={12}>
                <div className='channel-preview__label'>Preview</div>
                <p className='channel-preview__description'>This will look like this channel in the application</p>
              </Col>
              <Col span={12}>

                <div className='channel-preview__card' style={cardStyle}>
                  <div className='channel-preview__name'>{ name || selectedChannel.name }</div>
                </div>
              </Col>
            </Row>
          </div>
        </Form>
      </Modal>
    )
  }
}

export default Form.create()(channelEditModal)



// WEBPACK FOOTER //
// ./src/components/Modals/ChannelEditModal/ChannelEditModal.jsx